(function(){'use strict';function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}var TeamSection=function(e){_inherits(a,e);var t=_createSuper(a);function a(){var e;return _classCallCheck(this,a),(e=t.call(this)).setListeners(),e}return _createClass(a,[{key:"setListeners",value:function(){var e=this;this.querySelectorAll(".member").forEach((function(t){t.addEventListener("click",(function(a){a.preventDefault(),e.OnClick(t);}));}));}},{key:"OnClick",value:function(e){var t=e.getAttribute("data-index"),a=this.getRowIndex(t),i=this.getRowIndex(t,!0),r=this.getMemberData(t),l=5*a-1;window.matchMedia("(max-width: 749px)").matches&&(l=2*i-1),this.hideData(),this.showData(r,l),this.toggleActive(t);}},{key:"getRowIndex",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];return t?Math.trunc(parseInt(e,10)/2)+1:Math.trunc(parseInt(e,10)/5)+1}},{key:"getMemberData",value:function(e){var t=document.querySelector(".bubble-data .member-bubble[data-index='".concat(e,"']")),a=document.createElement("div");return a.classList.add("member-bubble","member-".concat(e,"-data")),a.innerHTML=t.innerHTML,a}},{key:"showData",value:function(e,t){var a,i=this,r=this.childElementCount;e.style.opacity="0",e.style.transition="opacity .5s linear",r>t?this.children[t].insertAdjacentElement("afterEnd",e):this.children[r-1].insertAdjacentElement("afterEnd",e),setTimeout((function(){e.style.opacity="1";}),100),null===(a=this.querySelector("[close-bubble]"))||void 0===a||a.addEventListener("click",(function(t){t.preventDefault(),i.hideData(e),i.toggleActive();}));}},{key:"hideData",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;if(null==e){var t=this.querySelectorAll(".member-bubble");t.forEach((function(e){e.remove();}));}else e.remove();}},{key:"toggleActive",value:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;this.querySelectorAll(".member").forEach((function(e){e.classList.remove("active");})),null!=t&&setTimeout((function(){e.children[t].classList.add("active");}),150);}}]),a}(_wrapNativeSuper(HTMLElement));customElements.define("team-section",TeamSection);})();